// Reads the ?ref=XXXX query param on any route and stores it in localStorage,
// so the referral survives across pages until the user finally registers.
// Persisted for 90 days.

const KEY = "gc_ref";
const KEY_AT = "gc_ref_at";
const MAX_AGE_MS = 90 * 24 * 3600 * 1000;

export function captureRefFromURL() {
  if (typeof window === "undefined") return;
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref && /^[A-Za-z0-9_-]{4,32}$/.test(ref)) {
      localStorage.setItem(KEY, ref.toUpperCase());
      localStorage.setItem(KEY_AT, String(Date.now()));
    }
  } catch (e) {
    // Fails only in private-mode / storage-disabled browsers; safe to skip.
    console.debug("refCapture.captureRefFromURL skipped:", e?.message || e);
  }
}

export function getStoredRef() {
  if (typeof window === "undefined") return null;
  try {
    const at = Number(localStorage.getItem(KEY_AT) || 0);
    if (!at || Date.now() - at > MAX_AGE_MS) {
      localStorage.removeItem(KEY);
      localStorage.removeItem(KEY_AT);
      return null;
    }
    return localStorage.getItem(KEY) || null;
  } catch { return null; }
}

export function clearStoredRef() {
  try {
    localStorage.removeItem(KEY);
    localStorage.removeItem(KEY_AT);
  } catch (e) {
    console.debug("refCapture.clearStoredRef skipped:", e?.message || e);
  }
}
